<template>
  <div class="adminAddBox">
    <Form ref="addForm" :label-width="130" :model="formCustom" :rules="addRules" inline>
      <Form-item label="公司名称：" prop="organizationName">
        <Input v-model="formCustom.organizationName" clearable placeholder="请输入" style="width: 240px"></Input>
      </Form-item>
      <br>
      <FormItem label="统一社会信用代码：" prop="organizationCode">
        <Input v-model="formCustom.organizationCode" :maxlength="50" clearable placeholder="请输入"
               style="width: 240px"></Input>
      </FormItem>
      <br>
    </Form>
    <div class="footerButton">
      <Button type="default" @click="handleBack('add')">返回</Button>
      <Button :loading="addLoading" style="margin-left: 10px" type="primary" @click="handleCommit('addForm')">
        <span v-if="!addLoading">提交</span>
        <span v-else>提交中</span>
      </Button>
    </div>
  </div>
</template>

<script>
import {companyAdd} from '@/api/organization'

export default {
  name: 'adminAdd',
  data() {
    return {
      addLoading: false,
      roleDisabled: true, // 关联角色disabled
      formCustom: {
        organizationName: '',
        organizationCode: ''
      },
      addRules: {
        organizationName: [{required: true, message: '公司名称不能为空', trigger: 'blur'}],
        organizationCode: [{required: true, message: '统一社会信用代码不能为空', trigger: 'blur'}]
      },
    }
  },
  mounted() {
  },
  methods: {
    // 返回
    handleBack() {
      this.$router.push(
        {
          path: '/organization/organization'
        }
      )
    },
    // 提交
    handleCommit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.addLoading = true
          companyAdd({...this.formCustom, organizationType: 1}).then((response) => {
            if (response.data.success === false) {
              this.$Message.error(response.data.msg)
              this.addLoading = false
            } else {
              this.$Message.success(response.data.msg)
              this.addLoading = false
              this.$router.push({path: '/organization/organization'})
            }
          }).catch(() => {
            this.addLoading = false
          })
        }
      })
    }
  }
}
</script>
